import { createSlice } from "@reduxjs/toolkit";

const initialorganizationReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  organizationReportForEdit: undefined,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminOrganizationReportSlice = createSlice({
  name: "organizationReport",
  initialState: initialorganizationReportState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      // state.error = `${action.type}: ${action.payload.error}`;
      // if (action.payload.callType === callTypes.list) {
      //   state.listLoading = false;
      // } else {
      //   state.actionsLoading = false;
      // }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getorganizationReportById
    organizationReportFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.organizationReportForEdit =
        action.payload.organizationReportForEdit;
    },
    // findorganizationReport
    organizationReportsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    organizationReportReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    }
  }
});
